module.exports = __webpack_public_path__ + "static/3dmodel06-96d9847f2d971235fe00a03d4d83cda8.jpg";